export const environment = {
  production: true,
  authority: {
    issuer: 'https://beta-auth.seepex.com',
    clientId: 'performance-data-online-web-client',
    redirectUri: 'https://beta-performance-data.seepex.com',
    scope: 'openid profile email performance-data-online-scope',
    response_type: 'code',
  },
  calculationApi: 'https://beta-performance-data-api.seepex.com',
  portalUrl: 'https://beta-portal.apps.seepex.com'
};
